import type { ReactNode } from 'react';

export const symbol_clock_loader_20: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M324-111.5Q251-143 197-197t-85.5-127Q80-397 80-480t31.5-156Q143-709 197-763t127-85.5Q397-880 480-880t156 31.5Q709-817 763-763t85.5 127Q880-563 880-480t-31.5 156Q817-251 763-197t-127 85.5Q563-80 480-80t-156-31.5Zm397-127.31q99-98.82 99-241.19H480.26v-340Q338-820 239-721t-99 241q0 142 99 241t241 99q142 0 241-98.81Z"
		/>
	</svg>
);
